import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { translate } from '../../../shared/translations.js';
import Translate from '../../base/Translate/Translate.js';

import { IRiskRatingConfiguration, IRiskRatingProps, IRiskRatingState } from './models/index.js';
import ActiveRatingBox from './styledComponents/ActiveRatingBox.js';
import BottomLabels from './styledComponents/BottomLabels.js';
import Label from './styledComponents/Label.js';
import LeftLabel from './styledComponents/LeftLabel.js';
import RatingBox from './styledComponents/RatingBox.js';
import Ratings from './styledComponents/Ratings.js';
import RightLabel from './styledComponents/RightLabel.js';
import TopLabels from './styledComponents/TopLabels.js';
import Wrapper from './styledComponents/Wrapper.js';
import { RISK_RATING_CATEGORY_KEY, RISK_RATING_COMPONENT_KEY } from './RiskRating.meta.js';

export class RiskRating extends ComponentBase<IRiskRatingProps, IRiskRatingState, IRiskRatingConfiguration> {
	categoryKey = RISK_RATING_CATEGORY_KEY;
	componentKey = RISK_RATING_COMPONENT_KEY;

	static defaultProps: IRiskRatingProps = {
		count: 7,
		value: 0,
	};

	constructor(props: IRiskRatingProps) {
		super(props);
	}
	renderTopLabels = () => {
		const { labels } = this.props;
		if (labels && labels.top) {
			return <TopLabels aria-hidden={true}>{this.renderLabelsChildren(labels.top)}</TopLabels>;
		}
		return null;
	};
	renderBottomLabels = () => {
		const { labels } = this.props;
		if (labels && labels.bottom) {
			return <BottomLabels aria-hidden={true}>{this.renderLabelsChildren(labels.bottom)}</BottomLabels>;
		}
		return null;
	};
	renderLabelsChildren = (labels: { left?: string; right?: string }) => {
		const { left, right } = labels;
		return (
			<Fragment>
				<LeftLabel>
					<Label>
						<Translate>{left || ''}</Translate>
					</Label>
				</LeftLabel>
				<RightLabel>
					<Label>
						<Translate>{right || ''}</Translate>
					</Label>
				</RightLabel>
			</Fragment>
		);
	};

	render() {
		const { className, count = 7, value, ratingsAccessibleText } = this.props;
		const ratings = Array(count).fill('');

		const placeholders = {
			count,
			value,
			startValue: 1,
		};
		const accessibleTextTemplate =
			ratingsAccessibleText ||
			`minimum value is {startValue}, maximum value is {count}, risk rating value is {value}`;
		const accessibleText = translate(accessibleTextTemplate, placeholders);

		return (
			<Wrapper className={className} role="text" aria-label={accessibleText}>
				{this.renderTopLabels()}
				<Ratings aria-hidden={true}>
					{ratings.map((element, index) => {
						const rating = index + 1;
						const isActive = Number(value) === rating;
						const Box = isActive ? ActiveRatingBox : RatingBox;
						return <Box key={rating}>{rating}</Box>;
					})}
				</Ratings>
				{this.renderBottomLabels()}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(RiskRating), RISK_RATING_CATEGORY_KEY, RISK_RATING_COMPONENT_KEY);
